/**
 * - Description -
 * ConversionService contains all the methods to convert some information from one format to another.
 *
 */
export default {
    name: 'ConversionService',
    fromBytesToKiloBytes: fromBytesToKiloBytes,
    fromBytesToMegaBytes: fromBytesToMegaBytes,
    fromBytesToGigaBytes: fromBytesToGigaBytes
}


function fromBytesToKiloBytes(sizeInBytes) {
    let sizeInKB = sizeInBytes / 1000;
    if (sizeInKB < 1) {
        return sizeInBytes.toFixed(2) + ' B';
    }
    return sizeInKB.toFixed(2) + ' KB';
}

function fromBytesToMegaBytes(sizeInBytes) {
    let sizeInMB = sizeInBytes / 1000000;
    if (sizeInMB < 1) {
        return fromBytesToKiloBytes(sizeInBytes)
    }
    return sizeInMB.toFixed(2)  + ' MB';
}

function fromBytesToGigaBytes(sizeInBytes) {
    let sizeInGB = sizeInBytes / 1000000000;
    if (sizeInGB < 1) {
        return fromBytesToMegaBytes(sizeInBytes)
    }
    return sizeInGB.toFixed(2) + ' GB';
}


